export const ENABLE_GUIDED_TOUR = true;
